import React from "react";
import { Button, TextArea } from "semantic-ui-react";

interface Props {
  item: server.dto.DocumentChecklistItem
  onDeclined: (reason: string) => void
}

const ChecklistNotAnsweredDeclineReasonRowCard = (props: Props) => {
  const [declinedReason, setDeclinedReason] = React.useState("");
  const [savingDecline, setSavingReject] = React.useState(false);

  const textAreaRef = React.useRef<TextArea>();

  const onDecline = () => {
    if (savingDecline) return;
    setSavingReject(true);
    props.onDeclined(declinedReason);
  };

  const { item } = props;
  return <div className="flex-column">
    <div className="grow1">
      <div>
        <h3>{item.question}</h3>
      </div>
    </div>

    <div>
      <TextArea
        value={declinedReason}
        placeholder={RESX.Checklist.ProvideAReasonWhyYouDecline}
        onChange={(_, { value }) => { setDeclinedReason(value as string); }}
        rows={7}
        maxLength={serverReference.constants.checklist.maxDeclinedReasonLength}

        ref={textAreaRef}
      />
      <div className="margin-top flex justify-end">
        <Button
          loading={savingDecline}
          color="red"
          onClick={onDecline}
        >
          {RESX.Buttons.Decline}
        </Button>
      </div>
    </div>
  </div>;
};

export default ChecklistNotAnsweredDeclineReasonRowCard;